import { Link } from "react-router-dom";
import { BedDouble, Bath, Users, ArrowUpRight } from "lucide-react";
import SmartImage from "./SmartImage";

const BADGE_STYLE = {
  "Available Now": "bg-[var(--ed-emerald)] text-[var(--ed-bg)]",
  "Reserved": "bg-[var(--ed-ink)] text-[var(--ed-bg)]",
  "High Demand": "bg-[var(--ed-ink)] text-[var(--ed-bg)]",
  "Limited Availability": "bg-[var(--ed-ink)] text-[var(--ed-bg)]",
  "Coming Soon": "bg-[var(--ed-paper)] text-[var(--ed-ink)] border border-[var(--ed-rule)]",
};

export default function PropertyCard({ property }) {
  const badgeCls = BADGE_STYLE[property.badge] || "bg-[var(--ed-ink)] text-[var(--ed-bg)]";
  return (
    <Link
      data-testid={`property-card-${property.id}`}
      to={`/properties/${property.id}`}
      className="group block bg-[var(--ed-bg)] border border-[var(--ed-rule)] hover:border-[var(--ed-ink)] transition-colors duration-500"
    >
      <div className="aspect-[4/3] overflow-hidden relative ed-photo">
        <SmartImage
          src={property.images?.[0]}
          alt={property.name}
          containerClassName="w-full h-full"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
        />
        {property.badge && (
          <span
            data-testid={`property-card-badge-${property.id}`}
            className={`absolute top-4 left-4 px-3 py-1.5 text-[0.6rem] tracking-[0.22em] uppercase font-medium ${badgeCls}`}
          >
            {property.badge}
          </span>
        )}
        <div className="absolute bottom-4 right-4 w-10 h-10 border border-[var(--ed-bg)]/60 bg-[var(--ed-ink)]/35 backdrop-blur-sm flex items-center justify-center text-[var(--ed-bg)] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
          <ArrowUpRight size={16} strokeWidth={1.6} />
        </div>
      </div>
      <div className="p-7">
        <div className="flex items-center gap-2 mb-3">
          <span className="ed-overline" style={{ fontSize: "0.62rem" }}>{property.category}</span>
          <span className="text-[var(--ed-ink-muted)] text-xs">·</span>
          <span className="text-[var(--ed-ink-muted)] text-xs tracking-wide">{property.location}</span>
        </div>
        <h3 className="font-serif text-2xl text-[var(--ed-ink)] mb-5 leading-tight group-hover:text-[var(--ed-emerald)] transition-colors duration-300">
          {property.name}
        </h3>
        <div className="flex items-center gap-5 text-[var(--ed-ink-soft)] text-xs mb-6">
          <span className="flex items-center gap-1.5"><BedDouble size={14} strokeWidth={1.4} /> {property.bedrooms} Bed</span>
          <span className="flex items-center gap-1.5"><Bath size={14} strokeWidth={1.4} /> {property.bathrooms} Bath</span>
          <span className="flex items-center gap-1.5"><Users size={14} strokeWidth={1.4} /> {property.guests} Guests</span>
        </div>
        <div className="flex items-end justify-between pt-5 border-t border-[var(--ed-rule)]">
          <div>
            <span className="font-serif text-2xl text-[var(--ed-ink)] leading-none">£{property.price_per_night}</span>
            <span className="text-[var(--ed-ink-muted)] text-xs ml-1">/ night</span>
          </div>
          <span className="text-[0.66rem] uppercase tracking-[0.22em] text-[var(--ed-ink)] group-hover:text-[var(--ed-emerald)] transition-colors">
            {property.bookable ? "Book →" : "Inquire →"}
          </span>
        </div>
      </div>
    </Link>
  );
}
